import { GRANULARITY_TRANSLATED } from '@/common/messages';
import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { APP_DICTIONARY } from '@/common/messages/root';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Dialog = defineMessages({
  title: {
    id: 'app.routes.exports.dialog.title',
    defaultMessage: 'Nastavení exportu',
  },
  exportData: {
    id: 'app.routes.exports.dialog.exportData',
    defaultMessage: 'Exportovaná data',
  },
  consumption: {
    id: 'app.routes.exports.dialog.consumption',
    defaultMessage: 'Spotřeby',
  },
  cost: APP_DICTIONARY.cost,
  invoice: {
    id: 'app.routes.exports.dialog.invoice',
    defaultMessage: 'Fakturační podklady',
  },
  max: APP_DICTIONARY.maximum,
  filter: {
    id: 'app.routes.exports.dialog.filter',
    defaultMessage: 'Filtr',
  },
  splitData: {
    id: 'app.routes.exports.dialog.splitData.title',
    defaultMessage: 'Rozdělit data',
  },
  splitDataNone: {
    id: 'app.routes.exports.dialog.splitData.none',
    defaultMessage: 'Nerozdělovat',
  },
  splitByCalculationMethods: {
    id: 'app.common.analysis.splitBy.calculationMethods',
  },
  splitDataEstablishments: APP_DICTIONARY.establishments,
  splitDataSource: {
    id: 'app.common.analysis.splitBy.dataSources',
  },
  splitDataMeters: APP_DICTIONARY.meters,
  splitDataCommodities: APP_DICTIONARY.commodities,
  splitDataSupplyPoints: APP_DICTIONARY.supplyPoints,
  splitDataTenants: APP_DICTIONARY.tenants,
  splitDataLeaseUnits: APP_DICTIONARY.leaseUnits,
  splitDataTags: {
    id: 'app.routes.exports.dialog.splitData.tags',
    defaultMessage: 'Vybrané značky',
  },
  granularity: {
    id: 'app.routes.exports.dialog.granularity',
    defaultMessage: 'Granularita dat',
  },
  transform: {
    id: 'app.routes.exports.dialog.transform.title',
  },
  transformSum: {
    id: 'app.routes.exports.dialog.transform.sum',
  },
  transformPerSquareMeter: {
    id: 'app.routes.exports.dialog.transform.perSquareMeter',
    defaultMessage: 'Na m²',
  },
  transformPerSquareMeterUnitCost: {
    id: 'app.routes.exports.dialog.transform.perSquareMeter.unitCost',
    defaultMessage: 'Cena za jednotku',
  },
  transformMaximum: APP_DICTIONARY.maximum,
  maxGranularity: {
    id: 'app.routes.exports.dialog.maxGranularity.title',
    defaultMessage: 'Rozlišení maxima',
  },
  maxGranularityNone: {
    id: 'app.routes.exports.dialog.maxGranularity.none',
    defaultMessage: 'Rozlišení maxima',
  },
  maxGranularityQuarterHour: GRANULARITY_TRANSLATED['quarter-hour'],
  maxGranularityHours: GRANULARITY_TRANSLATED.hour,
  maxGranularityDays: GRANULARITY_TRANSLATED.day,
  maxUnit: {
    id: 'app.routes.exports.dialog.maxUnit',
    defaultMessage: 'Jednotka maxima',
  },
  fileFormat: {
    id: 'app.routes.exports.dialog.fileFormat',
    defaultMessage: 'Formát souboru',
  },
  filename: {
    id: 'app.routes.exports.dialog.filename',
    defaultMessage: 'Název souboru',
  },
  cancel: TRANSLATED_ACTIONS.cancel,
  confirm: TRANSLATED_ACTIONS.export,
  settingsTitle: {
    id: 'app.routes.exports.dialog.settingsTitle',
  },
  filterTitle: {
    id: 'app.routes.exports.dialog.filterTitle',
  },
  fileNameError: {
    id: 'app.routes.exports.dialog.fileNameError',
  },
});

export const Table = defineMessages({
  name: {
    id: 'app.Export.Table.name',
    defaultMessage: 'Název exportu',
  },
  format: {
    id: 'app.Export.Table.format',
    defaultMessage: 'Formát',
  },
  download: TRANSLATED_ACTIONS.download,
});
